var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"max-width":"400","left":_vm.dir('left'),"right":_vm.dir('right'),"bottom":_vm.dir('bottom'),"top":_vm.dir('top')},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({staticClass:"info-icon ml-2",attrs:{"size":"18","color":"primary"}},on),[_vm._v(" mdi-information ")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }